import I from "./index459.js";
import { resolveComponent as c, createElementBlock as l, createCommentVNode as m, openBlock as n, normalizeClass as v, createElementVNode as r, withDirectives as S, createVNode as d, vShow as T, createTextVNode as f, toDisplayString as t, Fragment as _, renderList as h, createBlock as p, withCtx as N } from "vue";
/* empty css         */
import B from "./index231.js";
const R = ["data-component"], $ = { class: "ms-offcanvasNav__drawer" }, O = { class: "ms-offcanvasNav__nav" }, V = { class: "ms-offcanvasNav__layerWrapper" }, L = { class: "ms-offcanvasNav__body" }, D = ["href"], E = ["onClick"], H = ["href", "target", "rel", "onClick"], z = { class: "ms-offcanvasNav__body" }, F = ["href", "target", "rel"], M = {
  key: 0,
  class: "ms-offcanvasNav__link"
}, U = {
  key: 1,
  class: "ms-offcanvasNav__link"
}, W = ["href", "target", "rel", "onClick"], j = {
  key: 0,
  class: "ms-offcanvasNav__btnArea"
};
function q(o, a, G, J, K, P) {
  const y = c("ms-arrow-left"), g = c("ms-close"), k = c("ChannelIconHomeSvg"), C = c("ms-arrow"), A = c("ms-header-login"), b = c("ms-header-bookmark"), u = c("cs-secondary-button");
  return o.header ? (n(), l("section", {
    key: 0,
    class: v(["ms-offcanvasNav", { "-open": o.isOpen }]),
    "data-component": o.$options.name,
    onClick: a[2] || (a[2] = (...e) => o.clickAnywhere && o.clickAnywhere(...e))
  }, [
    r("div", $, [
      r("div", O, [
        S(r("div", {
          class: "ms-offcanvasNav__backBtn",
          onClick: a[0] || (a[0] = (...e) => o.closeLayer && o.closeLayer(...e))
        }, [
          d(y, { class: "ms-offcanvasNav__icon" })
        ], 512), [
          [T, o.isSubNavOpen]
        ]),
        r("div", {
          class: "ms-offcanvasNav__closeBtn",
          onClick: a[1] || (a[1] = (...e) => o.closeNav && o.closeNav(...e))
        }, [
          d(g, { class: "ms-offcanvasNav__icon" })
        ])
      ]),
      r("div", V, [
        r("nav", {
          class: v(["ms-offcanvasNav__level0", { "-open": o.isSubNavOpen }])
        }, [
          r("div", L, [
            r("a", {
              class: "ms-offcanvasNav__headline",
              href: o.header.homeUrl
            }, [
              d(k, { class: "ms-offcanvasNav__channelIcon" }),
              a[3] || (a[3] = f(" Alle Themen in ")),
              a[4] || (a[4] = r("br", null, null, -1)),
              f(" " + t(o.header.locationName), 1)
            ], 8, D),
            (n(!0), l(_, null, h(o.header.navigations, (e, s) => (n(), l("div", {
              key: s,
              class: v(["ms-offcanvasNav__link", { "-active": e.highlighted }]),
              onClick: (i) => (o.toggleSubNav(e.navigationId), o.linkTracking(s, o.level1, e.channelLabel, i))
            }, [
              f(t(e.channelLabel) + " ", 1),
              d(C, { class: "ms-offcanvasNav__icon" })
            ], 10, E))), 128)),
            (n(!0), l(_, null, h(o.header.firstLayerLinks, (e, s) => (n(), l("a", {
              key: e.text + s,
              class: "ms-offcanvasNav__link",
              href: e.url,
              target: e.target,
              rel: o.getRel(e.nofollow),
              onClick: (i) => o.linkTracking(o.header.navigations.length + s, o.level1, e.text, i)
            }, t(e.text), 9, H))), 128))
          ])
        ], 2),
        (n(!0), l(_, null, h(o.header.navigations, (e) => (n(), l("nav", {
          key: e.navigationId,
          class: v([{ "-open": o.isActive(e.navigationId) }, "ms-offcanvasNav__level1"])
        }, [
          r("div", z, [
            r("a", {
              class: "ms-offcanvasNav__headline",
              href: e.url,
              target: e.target,
              rel: o.getRel(e.nofollow)
            }, [
              d(k, {
                alt: "Icon der meinestadt.de Channel-Startseite",
                class: "ms-offcanvasNav__channelIcon"
              }),
              f(" " + t(e.introduction) + " ", 1),
              a[5] || (a[5] = r("br", null, null, -1)),
              f(" " + t(o.header.locationName), 1)
            ], 8, F),
            o.showLoginLink(e.channelLabel) ? (n(), l("div", M, [
              d(A, {
                link: o.getLoginLink(o.header)
              }, null, 8, ["link"])
            ])) : m("", !0),
            o.showBookmarks(e.channelLabel) ? (n(), l("div", U, [
              d(b)
            ])) : m("", !0),
            (n(!0), l(_, null, h(e.items, (s, i) => (n(), l("a", {
              key: i,
              class: v(["ms-offcanvasNav__link", { "-active": s.highlighted }]),
              href: s.url,
              target: s.target,
              rel: o.getRel(s.nofollow),
              onClick: (w) => o.linkTracking(i, o.level2, s.text, w)
            }, t(s.text), 11, W))), 128))
          ]),
          e.primaryAction || e.secondaryAction ? (n(), l("div", j, [
            e.secondaryAction ? (n(), p(u, {
              key: 0,
              isCentered: !0,
              target: e.secondaryAction.target,
              href: e.secondaryAction.url,
              rel: o.getRel(e.secondaryAction.nofollow),
              onClick: (s) => o.linkTracking("cta_secondary", o.level2, e.secondaryAction.text, s)
            }, {
              default: N(() => [
                f(t(e.secondaryAction.text), 1)
              ]),
              _: 2
            }, 1032, ["target", "href", "rel", "onClick"])) : m("", !0),
            e.primaryAction ? (n(), p(u, {
              key: 1,
              isCentered: !0,
              target: e.primaryAction.target,
              href: e.primaryAction.url,
              rel: o.getRel(e.primaryAction.nofollow),
              onClick: (s) => o.linkTracking("cta_primary", o.level2, e.primaryAction.text, s)
            }, {
              default: N(() => [
                f(t(e.primaryAction.text), 1)
              ]),
              _: 2
            }, 1032, ["target", "href", "rel", "onClick"])) : m("", !0)
          ])) : m("", !0)
        ], 2))), 128))
      ])
    ])
  ], 10, R)) : m("", !0);
}
const x = /* @__PURE__ */ B(I, [["render", q], ["__scopeId", "data-v-47fe3c3d"]]);
export {
  x as default
};
